const DEFAULT_MIN_DURATION_MS = 50;
const DEFAULT_MAX_DURATION_MS = 1500;
const DEFAULT_MAX_MOVEMENT_PX = 14;
/** Bind a deliberate press gesture; short taps, long holds and drags are ignored. */
export function bindGuardedPress(element, action, options = {}) {
    const minDurationMs = options.minDurationMs ?? DEFAULT_MIN_DURATION_MS;
    const maxDurationMs = options.maxDurationMs ?? DEFAULT_MAX_DURATION_MS;
    const maxMovementPx = options.maxMovementPx ?? DEFAULT_MAX_MOVEMENT_PX;
    let pointerId = null;
    let startedAt = 0;
    let startX = 0;
    let startY = 0;
    let movedTooFar = false;
    const reset = () => {
        pointerId = null;
        startedAt = 0;
        movedTooFar = false;
    };
    const onPointerDown = (event) => {
        if (element.getAttribute("aria-disabled") === "true" || event.button !== 0)
            return;
        pointerId = event.pointerId;
        startedAt = performance.now();
        startX = event.clientX;
        startY = event.clientY;
        movedTooFar = false;
        element.classList.add("guarded-press-active");
        element.setPointerCapture?.(event.pointerId);
    };
    const onPointerMove = (event) => {
        if (pointerId !== event.pointerId)
            return;
        if (Math.hypot(event.clientX - startX, event.clientY - startY) > maxMovementPx) {
            movedTooFar = true;
            element.classList.remove("guarded-press-active");
        }
    };
    const onPointerUp = (event) => {
        if (pointerId !== event.pointerId)
            return;
        const duration = performance.now() - startedAt;
        element.classList.remove("guarded-press-active");
        const run = !movedTooFar && duration >= minDurationMs && duration <= maxDurationMs &&
            element.getAttribute("aria-disabled") !== "true";
        reset();
        if (run) {
            event.preventDefault();
            action();
        }
    };
    const onPointerCancel = () => {
        element.classList.remove("guarded-press-active");
        reset();
    };
    element.addEventListener("pointerdown", onPointerDown);
    element.addEventListener("pointermove", onPointerMove);
    element.addEventListener("pointerup", onPointerUp);
    element.addEventListener("pointercancel", onPointerCancel);
    element.addEventListener("contextmenu", (event) => event.preventDefault());
    return () => {
        element.removeEventListener("pointerdown", onPointerDown);
        element.removeEventListener("pointermove", onPointerMove);
        element.removeEventListener("pointerup", onPointerUp);
        element.removeEventListener("pointercancel", onPointerCancel);
    };
}
//# sourceMappingURL=GuardedPress.js.map